<template>
  <TemplateView>
    <TemplatePage :loading="loading">
      <div class="container">
        <StatisticProjectReportsBlank
          :data="project"
          :date="{ start: today.getFullYear() + '-' + today.getMonth() + '-' + today.getDate() }"
        />
      </div>
    </TemplatePage>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TemplateView from '../../../components/templates/TemplateView'
import TemplatePage from '../../../components/templates/TemplatePage'
import StatisticProjectReportsBlank from '../../../components/timeControl/reports/StatisticProjectReportsBlank'

export default {
  name: 'timeControlShowReportsFree',
  components: { StatisticProjectReportsBlank, TemplatePage, TemplateView },
  data: () => ({
    loading: true,
    today: new Date(),
  }),
  computed: {
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('workClientPerson', ['workClientPersonShow']),
    project() {
      return {
        project: {
          id: this.workClientProjectShow.id,
          name: this.workClientProjectShow.name,
          city: this.workClientProjectShow.city,
          zip: this.workClientProjectShow.zip,
          street: this.workClientProjectShow.street,
          client: this.workClientProjectShow.work_client,
          manager: {
            first_name: this.workClientPersonShow ? this.workClientPersonShow.first_name : '',
            last_name: this.workClientPersonShow ? this.workClientPersonShow.last_name : '',
            phone: this.workClientPersonShow ? this.workClientPersonShow.phone : '',
          },
        },
      }
    },
  },
  created() {
    this.onFirstLoad()
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectShow']),
    ...mapActions('workClientPerson', ['onWorkClientPersonShow']),
    async onFirstLoad() {
      await this.onWorkClientProjectShow(this.$route.params.id)
        .then((res) => {
          this.onWorkClientPersonShow(res.data.data.contact_client_person_id)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped></style>
